// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__SU-5h","addWidgetButton":"Header_addWidgetButton__lE-97","dashboardTabs":"Header_dashboardTabs__2xtOO","active":"Header_active__2fo4H"};